import React from 'react';
import InfoNav from './containers/InfoNav';
import InfoContent from './containers/InfoContent';
import SEOMeta from 'containers/SEOMeta';
import { selectors } from './ducks/page.duck';

const InfoPage = () => (
  <div className="l-sub-page">
    <SEOMeta selector={selectors.data} />
    <div className="l-sub-page__aside">
      <InfoNav />
    </div>
    <div className="l-sub-page__main">
      <div className="l-static-page">
        <InfoContent />
      </div>
    </div>
  </div>
);

export default InfoPage;

